module.exports = __webpack_public_path__ + "img/kefu002.3c2a6be6.jpg";